import Footer from "@components/Footer";

function SignInPageContainer({
  children,
  showBg,
}: {
  children: React.ReactNode;
  showBg?: boolean;
}) {
  return (
    <div className="flex w-screen flex-col overflow-x-hidden">
      <div className="relative flex min-h-[90vh] flex-col items-center justify-center bg-gray-50">
        {showBg ? (
          <div className="absolute z-10 inline-flex w-full max-w-md justify-center rounded-3xl border bg-card px-8 py-16 shadow-sm backdrop-blur-md">
            {children}
          </div>
        ) : (
          <div className="absolute z-10">{children}</div>
        )}

        <div
          className="absolute top-0 h-[50vh] w-[105vw] rounded-b-[50%]"
          style={{
            background: `linear-gradient(90deg, #E3E3E3 10.8%, #F3ECDB 29.15%, #B9F2F4 63.92%, #9BEEC0 92.74%)`,
          }}
        ></div>
      </div>
      <Footer />
    </div>
  );
}

export default SignInPageContainer;
